<template functional>
  <div class="foo" v-if="$options.customRender(props)">
    <el-avatar
      v-if="!$options.customRender(props).imageUrl"
      size="small"
      src="/static/images/avatar-2.jpg"
    ></el-avatar>
    <el-avatar
      v-else
      size="small"
      :src="$options.customRender(props).imageUrl"
    ></el-avatar>
    <span>{{ $options.customRender(props).Name }}</span>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "ImagePersonByEmployee",
  customRender(props) {
    return _.get(props.row, props.column);
  }
};
</script>

<style scoped>
.foo {
  height: auto;
}
.foo span {
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
}
.foo span:first-child {
  margin-right: var(--flex-gap, 0.5em);
}
</style>
